import { createContext, useContext, useState } from 'react';

const SideBarStateContext = createContext();

export const SideBarState = () => useContext(SideBarStateContext);

export const SideBarStateProvider = ({ children }) => {
  const [currentState, setCurrentState] = useState(-1);

  const toggleState = () => {
    setCurrentState((prevState) => (prevState === -1 ? 2 : -1));
  };

  return (
    <SideBarStateContext.Provider value={{ currentState, toggleState }}>
      {children}
    </SideBarStateContext.Provider>
  );
};
